module.exports = __webpack_public_path__ + "img/lw-logo-name.4e31ef83.png";